import { useEffect } from 'react';

// mermaid is imported on demand because this component is re-exported through the
// shared-web barrel, which every frontend's entry imports — a static import here
// (plus mermaid's import-time initialization) would drag the mermaid runtime into
// the app, portal, and investor entry bundles even though only internal admin
// views ever render a chart.
let mermaidLoader: Promise<typeof import('mermaid')> | undefined;
const loadMermaid = () => {
  mermaidLoader ??= import('mermaid').then((module) => {
    module.default.initialize({});
    return module;
  });
  return mermaidLoader;
};

export type MermaidChartProps = {
  chart: string;
  id: string;
};

export const MermaidChart = ({ chart, id }: MermaidChartProps) => {
  useEffect(() => {
    let cancelled = false;
    void loadMermaid().then(({ default: mermaid }) => {
      if (cancelled) {
        return;
      }
      document.getElementById(id)?.removeAttribute('data-processed');
      mermaid.contentLoaded();
    });
    return () => {
      cancelled = true;
    };
  }, [chart, id]);

  return (
    <div className="mermaid" id={id}>
      {chart}
    </div>
  );
};
